<template>
  <div class="flex-fill-center gap-2 bg-danger-subtle">
    <slot />
    <slot name="retry-button">
      <GuButton v-if="props.canRetry" variant="dark" @click="$emit('retry')">
        Retry
      </GuButton>
    </slot>
  </div>
</template>

<script setup>
import { GuButton } from '@shared/gu-components/button'

const props = defineProps({
  canRetry: {
    type: Boolean,
  },
})
defineEmits(['retry'])
</script>
